import React from 'react';

function PackageBath() {
	return (
		<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108.8 108.8">
			<g id="Layer_2" data-name="Layer 2">
				<g id="Base_Circle" data-name="Base Circle">
					<path d="M54.4,3A51.4,51.4,0,1,1,3,54.4,51.46,51.46,0,0,1,54.4,3m0-3a54.4,54.4,0,1,0,54.4,54.4A54.4,54.4,0,0,0,54.4,0Z" />
				</g>
				<g id="Bath">
					<line className="cls-1" x1="34.2" y1="37.17" x2="54.2" y2="37.17" />
					<path className="cls-2" d="M44.2,36.25V30.55A5.72,5.72,0,0,1,50.05,25H68.75a5.72,5.72,0,0,1,5.86,5.54V85.8" />
					<line className="cls-3" x1="44.2" y1="47.84" x2="44.2" y2="48.27" />
					<line className="cls-4" x1="44.2" y1="53.92" x2="44.2" y2="70.9" />
					<line className="cls-3" x1="44.2" y1="73.73" x2="44.2" y2="74.16" />
					<line className="cls-3" x1="54.2" y1="47.84" x2="54.2" y2="48.27" />
					<line className="cls-4" x1="54.2" y1="53.92" x2="54.2" y2="70.9" />
					<line className="cls-3" x1="54.2" y1="73.73" x2="54.2" y2="74.16" />
					<line className="cls-3" x1="34.19" y1="47.84" x2="34.19" y2="48.27" />
					<line className="cls-4" x1="34.19" y1="53.92" x2="34.19" y2="70.9" />
					<line className="cls-3" x1="34.19" y1="73.73" x2="34.19" y2="74.16" />
				</g>
			</g>
		</svg>
	);
}

export default PackageBath;


/** WEBPACK FOOTER **
 ** ./src/modules/images/PackageBath.js
 **/